module.exports = __webpack_public_path__ + "img/charity_jar_2.540581eb.png";